import TextPage from "./TextPage";

const Privacy = () => {
    return (
        <TextPage>
            <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>

            <h2 className="text-xl font-semibold mt-6 mb-2">Introduction</h2>
            <p className="mb-4">
                Ananas Calorie Tracker ("we") is a global application and website for monitoring nutrition and health,
                available to users worldwide. This privacy policy applies to all users of Ananas Calorie Tracker services –
                including the mobile app and website. By using Ananas Calorie Tracker, you agree to the data processing
                practices described in this policy. We are committed to protecting your privacy and
                complying with data protection laws.


                <br /><br />
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2 ">Data We Collect</h2>
            <p className="mb-4">
                When creating an account on Ananas Calorie Tracker, certain personal information is required to provide
                services. This information includes:
                <br /><br />
                <strong>Account Information:</strong> Name and contact details such as email or phone number and country of residence.
                <br />
                <strong>Personal Details:</strong> Age, height, weight, gender.
                <br />
                <strong>Health Information:</strong> Pregnancy status, breastfeeding, medical conditions,
                and daily activity.
                <br />
                <strong>Derived Data:</strong> Such as Body Mass Index (BMI).
                <br />
                <strong>Usage Data:</strong> Including how you use the app and website.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2 ">How We Use Your Information</h2>
            <p className="mb-4">
                We use the collected data for the following purposes:
                <br />
                - Providing core services such as BMI calculation and calorie tracking
                <br />
                - Improving user experience and personalizing the program
                <br />
                - Customer support and responding to requests
                <br />
                - Sending notifications and service-related communications
                <br />
                - Complying with regulations including U.S Sanctions and export control
                <br />
                - preventing misuse, and ensuring data security
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2 ">Data Security</h2>
            <p className="mb-4">
                We use encryption methods and security measures such as HTTPS for the secure transmission
                of information. Your sensitive data is stored on secure servers.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2 ">Your Rights Regarding Personal Data</h2>
            <p className="mb-4">
                As a Ananas Calorie Tracker user, you have the following rights:
                <br />
                - Right to access your data
                <br />
                - Right to correct or update information
                <br />
                - Right to delete data
                <br />
                - Right to transfer data in digital file format
                <br />
                - Right to object to data processing
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2 ">Contact Us</h2>
            <p className="mb-4">
                If you have any questions, concerns, or requests regarding this privacy policy, please
                contact us via email at{" "}
                <a className="text-blue-400" href="mailto:privacy@ananas.site">
                    privacy@ananas.site
                </a>.
            </p>

            <p className="mt-6 text-center text-sm text-gray-500">
                Ananas Calorie Tracker | Free version for Android and iOS
            </p>
        </TextPage>
    );
};

export default Privacy;
